import { Box, Checkbox } from "@outschool/backpack";
import {
  ActivityListing_ListingFragment,
  SectionRibbon_SectionFragment,
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { TrackingProperties } from "@outschool/ui-legacy-component-library";
import React from "react";

import { SaveHeart } from "../../saving/SaveButton";
import Badges from "./Badges";

/**
 * Contains the top bar of the search results gallery experiment listing card.
 * General layout:
 * - Checkbox (for comparing)
 * - Badges
 * - Save heart
 *
 * This component is new for the gallery experiment.
 */
export default function TopBar({
  section,
  activity,
  trackingProperties,
  isActivitySavedByCurrentUser,
  disabled,
  leader,
  isComparing,
  isSelected,
  isCheckboxDisabled,
  onSelectToCompare,
}: {
  section: SectionRibbon_SectionFragment | null;
  activity: ActivityListing_ListingFragment["activity"];
  trackingProperties?: TrackingProperties;
  isActivitySavedByCurrentUser: boolean;
  disabled: boolean;
  leader: ActivityListing_ListingFragment["leader"];
  isComparing: boolean;
  isSelected: boolean;
  isCheckboxDisabled: boolean;
  onSelectToCompare?: () => void;
}) {
  const { t } = useTranslation(
    "client\\components\\search\\searchResultsGalleryExperiment\\BadgeArea",
  );
  return (
    <Box
      flex
      sx={{
        justifyContent: "space-between",
        alignItems: "center",
        paddingX: "4px",
      }}
    >
      <Box flex sx={{ alignItems: "center", gap: "0.25em" }}>
        {isComparing && (
          <Checkbox
            checked={isSelected}
            disabled={isCheckboxDisabled}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              onSelectToCompare?.();
            }}
            aria-label={t("Compare class: {{classTitle}}", {
              classTitle: activity.titleTranslated,
            })}
            sx={{
              padding: 0,
            }}
            size="medium"
          />
        )}
        <Badges section={section} activity={activity} />
      </Box>
      <Box
        flex
        sx={{
          flexGrow: 1,
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <SaveHeart
          isSet={isActivitySavedByCurrentUser}
          activity={activity}
          leader={leader}
          trackingProperties={trackingProperties}
          disabled={disabled}
          sx={{ fontSize: "24px" }}
        />
      </Box>
    </Box>
  );
}
